import { render, staticRenderFns } from "./TestLevelTitle.vue?vue&type=template&id=53af4256&scoped=true&"
import script from "./TestLevelTitle.vue?vue&type=script&lang=js&"
export * from "./TestLevelTitle.vue?vue&type=script&lang=js&"
import style0 from "./TestLevelTitle.vue?vue&type=style&index=0&id=53af4256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af4256",
  null
  
)

export default component.exports